export default {
  title: {
    en: 'Oops!',
  },
  text: {
    en: `That product is temporarily out stock. All limited edition items are subject to availability. 
    We will notify you when the product becomes available.`,
  },
}
